module.exports = __webpack_public_path__ + "3477e21224d42f4a84f64cfd9700b6d6.pdf";